export const listRestaurants = /* GraphQL */ `
  query ListRestaurants($groupName: String, $nextToken: String) {
    restaurantsByGroupName(groupName: $groupName, nextToken: $nextToken) {
      items {
        id
        name
        userId
        displayDate
        displayLogo
        displayCurrencySymbol
        introduction
        logoKey
        backgroundImageKey
        displayBackground
        displayLogoInQRCode
        restaurantUrl
        menusPosition
        paidMenus
        paidMenuImages
        bookmarksEnabled
        paidBookmarks
        loadSectionOnly
        zoomDisabled
        restaurantName {
          color
          font
          textstyle
          format
        }
        dateText {
          color
          font
          textstyle
          format
        }
        descriptionText {
          color
          font
          textstyle
          format
        }
        menus {
          items {
            id
            name
            isPublished
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              headerFour {
                color
                font
                textstyle
                format
              }
              headerOne {
                color
                font
                textstyle
                format
              }
              headerThree {
                color
                font
                textstyle
                format
              }
              headerTwo {
                color
                font
                textstyle
                format
              }
              normalText {
                color
                font
                textstyle
                format
              }
              subtext {
                color
                font
                textstyle
                format
              }
            }
            description
            fileLocation
            menuUrl
            qrCodeImage
            restaurant {
              id
              name
              displayLogoInQRCode
              backgroundImageKey
              logoKey
              displayBackground
              paidMenus
              paidMenuImages
              dateText {
                color
                font
                textstyle
                format
              }
              restaurantName {
                color
                font
                textstyle
                format
              }
              descriptionText {
                color
                font
                textstyle
                format
              }
            }
          }
        }
      }
    }
  }
`;
